<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox" :style="{'width': window.width + 'px', 'height': windowHeight + 'px'}">
      <div class="fullbox_cont">
        <component :is="$route.params.fail"></component>
        <div class="text-center mt50">
          <button class="btn btn_normalBtn"
                  id="btnToSupport"
                  type="button"
                  @click="funcSupport">{{ $t('connectFailed.btnSupport') }}</button>
          <button class="btn btn_normalBtn"
                  id="btnToReconnect"
                  type="button"
                  @click="funcReconnect">{{ $t('connectFailed.btnReconnect') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { windowsResize } from '@/mixins/windows-resize';
import { mapGetters } from 'vuex';
import errorDGUsb from '@/components/errorMeg-components/ErrorDGUsb.vue';
import errorAPI from '@/components/errorMeg-components/ErrorAPICode.vue';
import errorBikeInfo from '@/components/errorMeg-components/ErrorBikeInfomation.vue';
import errorWriteBike from '@/components/errorMeg-components/ErrorWriteInBike.vue';
import errorDifferentPN from '@/components/errorMeg-components/ErrorDifferentPN.vue';
import errorTurnOn from '@/components/errorMeg-components/ErrorTurnOnBike.vue';

export default {
  name: 'ConnectBike',
  mixins: [ windowsResize ],
  data () {
    return {
      strErrcode: '',
      strErrMsg: ''
    };
  },
  components: {
    'ComportError': errorDGUsb,
    'APIError': errorAPI,
    'ReadInfoError': errorBikeInfo,
    'WriteInfoError': errorWriteBike,
    'BikeError': errorWriteBike,
    'PowerError': errorTurnOn,
    'PNError': errorDifferentPN
  },
  computed: {
    ...mapGetters({
      getMGopen: 'bikeConnect/getMGopen'
    }),
    errorState () {
      return {
        VinType: this.getBikeVINsituation.VIN_Type || '0',
        VinCode: this.getBikeVINsituation.VIN_Code
      };
    },
    windowHeight () {
      let oriHeight = this.window.height;
      if (oriHeight !== null) {
        oriHeight -= 151;
      }
      return oriHeight;
    }
  },
  methods: {
    funcReconnect () {
      this.$store.dispatch('bikeConnect/setBikeFlag', true);
      this.$router.push('/connect');
    },
    funcSupport () {
      this.$router.push('/support');
    },
    // 目前尚未用到此function
    funcErrMsg () {
      let type = this.errorState.VinType;
      let code = this.errorState.VinCode;
      if (type === '4') {
        this.strErrcode = code;
        this.strErrMsg = '.system';
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fullbox {
  position: relative;
  overflow: hidden;
}
</style>
